import { ImportButton, QuizFilters } from 'components/Quizzes/Controls';
import QuizList from 'components/Quizzes/QuizList';
import { useTranslation } from 'react-i18next';
import { Container, Stack, Text } from 'shell/components';

const Mobile = () => {
    const { t } = useTranslation('quiz');

    return (
        <Container device={'mobile'}>
            <Stack sx={{ width: '100%', pb: 5 }} spacing={5}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={4}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('quizzes', 'Quizzes')}
                    </Text>
                    <ImportButton />
                </Stack>
                <Stack alignItems={'center'} direction={'row'} spacing={4}>
                    <QuizFilters compact />
                </Stack>
                <QuizList />
            </Stack>
        </Container>
    );
};

export default Mobile;
